import { Injectable } from "@angular/core";

@Injectable()
export class FormValidatorHelper {
    public emailValidator(control) {
        // RFC 2822 compliant regex
        if (
            control.value != null &&
            // eslint-disable-next-line max-len
            control.value.match(/[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/)) {
            return null;
        }
        return { "invalidEmailAddress": true };
    }

    public passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value != null && control.value.length > 3) {
            return null;
        }
        return { "invalidPassword": true };

    }

    public passwordMatchValidator(control) {
        if (
            control.parent != null &&
            control.parent.controls.newPassword.value === control.parent.controls.confirmNewPassword.value) {
            return null;
        }
        return { "passwordMismatch": true };

    }
}
